export const SET_SHOW_INFOMODAL_HOME = "SET_SHOW_INFOMODAL_HOME"
export const SET_SHOW_INFOMODAL_OFFER = "SET_SHOW_INFOMODAL_OFFER"